import { axiosGet, axiosPost } from "../options/header"


//poziv express-u da dohvati podatke vezane uz osobu
export default {
  /**
   * Get all emails with pagination
   * @param {string} accessToken - Access token (deprecated, uses store)
   * @param {number} skip - Number of items to skip
   * @param {string} case_id - Case ID filter
   */
  getAll(accessToken, skip, case_id) {
    return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/email", {
      params: {
        skip,
        case_id,
      }
    });
  },

  /**
   * Search emails
   * @param {string} accessToken - Access token (deprecated, uses store)
   * @param {number} skip - Number of items to skip
   * @param {string} srch_txt - Search text
   */
  getAllSrch(accessToken, skip, srch_txt) {
    return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/email/search", {
      params: {
        skip,
        srch_txt
      }
    });
  },

  /**
   * Get email by ID
   * @param {string} accessToken - Access token (deprecated, uses store)
   * @param {string} id - Email ID
   */
  getById(accessToken, id) {
    return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/email/" + id, {
      params: {}
    });
  },

  /**
   * Save email to PDF
   * @param {string} accessToken - Access token (deprecated, uses store)
   * @param {string} id - Email ID
   * @param {string} groupId - Group/Case ID
   * @param {string} sid - Folder/Spis ID
   * @param {number} page_count - Number of pages
   * @param {object} html_to_upload - Email HTML content
   */
  saveEmail(accessToken, id, groupId, sid, page_count, html_to_upload) {
    return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/email/" + id + "/save-to-pdf", {
      groupId,
      sid,
      page_count,
      html_to_upload
    });
  },

  /**
   * Save email attachment
   * @param {string} accessToken - Access token (deprecated, uses store)
   * @param {string} id - Email ID
   * @param {string} groupId - Group/Case ID
   * @param {string} sid - Folder/Spis ID
   * @param {object} file_to_upload - File to upload
   * @param {boolean} need_to_pdf - Whether to convert to PDF
   */
  saveEmailAttachment(accessToken, id, groupId, sid, file_to_upload, need_to_pdf = false) {
    return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/email/" + id + "/save-attachment", {
      params: { groupId, sid, file_to_upload, need_to_pdf }
    });
  },
};
